/**
 * Created by lvxin on 2018/4/18.
 */
// import axios from 'axios'
// import env from '../../build/env'
// import semver from 'semver'
// import packjson from '../../package.json'

let util = {

}
/**
 *
 * How to user:
 * var date = new Date(time);
 * return formatDate(date, 'yyyy-MM-dd hh:mm');
 * @param date
 * @param fmt
 * @returns {*}
 */
util.formatDate = function (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

/**
 * 生成uuid
 * @returns {uuid - xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx}
 */
util.uuid = function () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  }).toUpperCase()
}

/*  tree 数据转换
   * @param {Array} tree 待转换的
   * tree * @param {Object} map 键值对映射
   * @return {Array} 转换后的 tree
  */
util.convertTree = function convertTree (tree, map) {
  const result = []
  // 遍历
  tree.forEach((item) => {
    // 读取 map 的键值映射
    const value = item[ map.value ]
    const label = item[ map.label ]
    let children = item[ map.children ]
    // 如果有子节点，递归
    if (children) {
      children = convertTree(children, map)
    }
    result.push({
      value,
      label,
      children
    })
  })
  return result
}

export default util



// WEBPACK FOOTER //
// ./src/libs/torinosrc-utils.js